import styled from 'styled-components';
import { colors, breakpoints } from '../../ui/variables';

export const NotificatioItemStyle = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 81px;
  background-color: #ffffff;
  border-radius: 19px;
  margin-top: 8px;
  padding: 11px 22px 13px 23px;

  .notification-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 65%;
    
    span {
      display: block;
      text-align: start;
      color: ${colors.veryDarkGray};
      font-size: 14px;
      line-height: 1.2;
    }
    
    .exam-main-message {
      font-weight: 600;
    }
  }

  .notification-right-column {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    text-align: right;
    width: 35%;
  }

  .notification-date-time-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: ${colors.grayishBlue};
    font-size: 12px;
    margin-bottom: 8px;
    .date {
      margin-right: 5px;
    }
  }
  
  .notification-status, .notification-viewed {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 61px;
    background-color: ${colors.softBlue};
    color: #fff;
    font-size: 14px;
    border-radius: 11.5px;
    margin-top: 5px;
  }

  .notification-viewed {
    background-color: ${colors.veryPaleBlue};
    color: ${colors.grayishBlue};
  }

  .notification-date, .notification-status-viewed {
    display: none;
  }
`;